import { createContext, useState } from "react";

const AppConfigContext = createContext();

function AppConfigProvider({ children }) {
  const [usage, setUsage] = useState(0);
  const [maxFileSize, setMaxFileSize] = useState(0);
  const [maxSpace, setMaxSpace] = useState(0);
  const [demo, setDemo] = useState(false);
  const [maxLinkCesium, setMaxLinkCesium] = useState(0);
  const [usedCesiumLinks, setUsedCesiumLinks] = useState(0);

  const configValue = {
    usage,
    setUsage,
    maxSpace,
    setMaxSpace,
    maxFileSize,
    setMaxFileSize,
    demo,
    setDemo,
    maxLinkCesium,
    setMaxLinkCesium,
    usedCesiumLinks,
    setUsedCesiumLinks
  };

  return (
    <AppConfigContext.Provider value={configValue}>{children}</AppConfigContext.Provider>
  );
}

export { AppConfigProvider, AppConfigContext };